import { useGetApplication } from '../../../hooks';

export interface Jurisdiction {
  id: string;
  name: string;
  color: string;
}

export const useGetJurisdictions = () => {
  const [{ data = [], loading, error }] = useGetApplication<Array<Jurisdiction>>({
    url: '/jurisdictions',
    params: {}
  });
  return { data, loading, error };
};
